import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/auth";
import financialReducer from "./slices/financial";
import messageReducer from "./slices/message";
import ordersReducer from "./slices/orders";
import packagesReducer from "./slices/packages";
import supplierPackagesReducer from "./slices/supplierPackages";
import suppliersReducer from "./slices/suppliers";
import uiReducer from "./slices/ui";
import userReducer from "./slices/user";

const reducer = {
  auth: authReducer,
  message: messageReducer,
  user: userReducer,
  ui: uiReducer,
  packages: packagesReducer,
  suppliers: suppliersReducer,
  supplierPackages: supplierPackagesReducer,
  orders: ordersReducer,
  financial: financialReducer,
};

const store = configureStore({
  reducer: reducer,
  devTools: true,
});

export default store;
